<template>
    <div @click="containerClicked" :class="[{'active' : checked},'inputContainer']">
        <input  type="checkbox" :id="id" v-model="checked" :disabled="disabled" v-on:change="updateValue"
               v-init:checked="initial">
        <label :for="id">{{ label }}</label>
        <span class="labelDetail">{{labelDetail}}</span>
    </div>
</template>

<script>
    export default {
        name: "XXLCheckbox",
        directives: {
            init: {
                bind: function (el, binding, vnode) {
                    vnode.context[binding.arg] = binding.value;
                }
            }
        },
        data: function () {
            return {
                checked: false,
            }
        },
        props: {
            disabled: {
                type: Boolean
            },
            label: {
                type: String,
                required: true
            },
            labelDetail: {
                type: String
            },
            initial: {
                type: Boolean
            },
            id: {
                type: String,
                required: true
            }
        },
        methods: {
            updateValue: function (ev) {
                ev.preventDefault();
                this.$emit('change', this.checked);
            },
            containerClicked: function (ev) {
                ev.preventDefault();
                this.checked = !this.checked;
                this.updateValue(ev);
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .inputContainer {
        position: relative;
        background-color: #CFD1D8;
        padding: 13px 10px 12px 10px;
        cursor: pointer;
        top: -3px;

        label{
            font-size: 15px;
            position:relative;
            top:5px;
        }
    }

    input {
        font-size: 1em;
    }

    input[type="checkbox"] {
        display: none;
    }

    input[type="checkbox"] + label::before {
        width: 12px;
        height: 12px;
        background-color: #fff;
        display: block;
        content: "";
        float: left;
        margin-right: 8px;
        border: 2px solid #fff;
        border-radius: 3px;
        top: -5px;
        position: relative;
    }

    input[type="checkbox"]:checked + label::before {
        background-color: #000;
    }

    input:disabled {
        background: transparent;
        border-color: transparent;
        border-bottom: 1px solid #ccc;
        color: black;
    }

    .labelDetail {
        position: absolute;
        left: 34px;
        top: 6px;
        font-size: 11px;
        color: #777;
        pointer-events: none;
    }

    .inputContainer.active, .inputContainer.active > .labelDetail {
        background-color: $blue;
        color: #fff;
    }

    label, .labelDetail {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
        cursor: pointer;
    }

</style>